import { render, staticRenderFns } from "./ShopeeConnectionCard.vue?vue&type=template&id=d3caf40c"
import script from "./ShopeeConnectionCard.vue?vue&type=script&lang=js"
export * from "./ShopeeConnectionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports